import {useEffect} from "react";
import {useSelector} from "react-redux";

import {ApplicationState} from "../store";
import {APIState} from "../store/API/types";
import service from "../services";


const useHeartBeatenPane = (pane: number) => {
    const { token } = useSelector<ApplicationState, APIState>(state => state.API);
    //
    useEffect(() => {
        if (service.doPaneHeartBeat) {
            const interv = setInterval(() => {
                service.doPaneHeartBeat(token, pane)
            }, 10000);

            return () => {
                clearInterval(interv)
            }
        }

    }, []);
};

export default useHeartBeatenPane